import { ActionNames } from '@wix/editor-platform-host-integration-apis';
import { ActionStylePreset } from '../../../../ui/globalDesignPanel/types';

const stylePresetsStore = new Map<ActionNames, ActionStylePreset[]>();

const setStylePresets = (
  actionName: ActionNames,
  stylePresets: ActionStylePreset[],
) => {
  stylePresetsStore.set(actionName, stylePresets);
};

const getStylePresets = (actionName: ActionNames) => {
  return stylePresetsStore.get(actionName) ?? undefined;
};

export const EditActionsPresetsStore = {
  setStylePresets,
  getStylePresets,
};
